import { render, staticRenderFns } from "./MergeSecondaryContactModal.vue?vue&type=template&id=b9bcd2d0"
import script from "./MergeSecondaryContactModal.vue?vue&type=script&lang=js"
export * from "./MergeSecondaryContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports